'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _cmsComponentUtilities = require('@viskan/cms-component-utilities');

var _viskanDekuGrid = require('viskan-deku-grid');

var _config = require('../config');

var _methods = require('../methods');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderType = function renderType(item, sku, props) {
	switch (item.key) {
		case 'media':
			{
				return (0, _magicVirtualElement2.default)(_cmsComponentUtilities.Image, { 'class': props.styleClasses.Thumbnail, source: item.value, scale: 'thumbnail' });
			}
		case 'qty':
			{
				if (!sku.inStock) {
					return (0, _magicVirtualElement2.default)(
						'span',
						{ 'class': props.styleClasses.Out_Of_Stock },
						'Out of stock'
					);
				}

				return (0, _magicVirtualElement2.default)('input', { 'class': props.styleClasses.Quantity_Input, type: 'number', value: '0', onChange: props.changeBuyList(sku) });
			}
		default:
			{
				return item.value;
			}
	}
}; /** @jsx dom */
/* eslint react/jsx-key: 0 */


var renderCells = function renderCells(sku, article, props) {
	var cellData = (0, _methods.getCellData)(_config.fields, article, sku, props);

	return cellData.map(function (item) {
		return (0, _magicVirtualElement2.default)(
			_viskanDekuGrid.Cell,
			{ size: item.sizes.mobile, 'md-size': item.sizes.tablet, 'lg-size': item.sizes.desktop },
			(0, _magicVirtualElement2.default)(
				'div',
				{ 'class': props.styleClasses.Cell, 'data-style-attr': 'Cell', style: { textAlign: item.align } },
				renderType(item, sku, props)
			)
		);
	});
};

var renderRows = function renderRows(props) {
	return props.article.articleAttributes.map(function (sku, i) {
		var isOdd = (i + 1) % 2;

		return (0, _magicVirtualElement2.default)(
			_viskanDekuGrid.Grid,
			{ key: sku.attr1_id + '_' + sku.attr2_id + '_' + sku.attr3_id, 'class': [props.styleClasses.Row, isOdd ? props.styleClasses.Row_Odd : props.styleClasses.Row_Even], 'data-style-attr': 'Row' },
			renderCells(sku, props.article, props)
		);
	});
};

var render = function render(_ref) {
	var props = _ref.props;

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Component-SKU-Table-Rows', props.styleClasses.Rows_Wrapper], 'data-style-attr': 'Rows_Wrapper' },
		(0, _magicVirtualElement2.default)(
			'div',
			null,
			renderRows(props)
		),
		(0, _magicVirtualElement2.default)('noscript', { 'data-style-attr': 'Row_Even' }),
		(0, _magicVirtualElement2.default)('noscript', { 'data-style-attr': 'Row_Odd' }),
		(0, _magicVirtualElement2.default)('noscript', { 'data-style-attr': 'Quantity_Input' }),
		(0, _magicVirtualElement2.default)('noscript', { 'data-style-attr': 'Thumbnail' }),
		(0, _magicVirtualElement2.default)('noscript', { 'data-style-attr': 'Out_Of_Stock' })
	);
};

exports.default = { render: render, name: 'CMS-Component-SKU-Table-Rows' };